// Phase 14e-a — /admin/rates parent layout.
//
// Three child routes (cards / modifiers / facility-overrides) consume
// the shared <SupersedableResourcePanel>. This parent renders the tab
// strip + <Outlet /> per Phase 14e-a-1 (parent-route layout pattern).
// routes/rates/index.tsx redirects to /rates/cards.

import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { AdminLayout } from '../components/AdminLayout';
import { adminBeforeLoad } from '../lib/admin-before-load';

export const Route = createFileRoute('/rates')({
  beforeLoad: () => adminBeforeLoad('/rates'),
  component: RatesLayout,
});

function RatesLayout() {
  return (
    <AdminLayout>
      <div className="space-y-6">
        <header>
          <h1 className="font-heading text-3xl text-forest md:text-4xl">Rate management</h1>
          <p className="mt-1 text-sm text-ink-muted">
            Manage rate cards, modifiers, and facility-specific bill-rate
            overrides. All changes follow the 14-day lead-time rule unless
            explicitly overridden.
          </p>
        </header>
        <nav className="flex gap-6 border-b border-border">
          <RatesTab to="/rates/cards" label="Cards" />
          <RatesTab to="/rates/modifiers" label="Modifiers" />
          <RatesTab to="/rates/facility-overrides" label="Facility overrides" />
        </nav>
        <Outlet />
      </div>
    </AdminLayout>
  );
}

function RatesTab({ to, label }: { to: string; label: string }) {
  return (
    <Link
      to={to}
      className="pb-3 text-sm font-heading text-ink-muted hover:text-forest"
      activeProps={{ className: 'pb-3 text-sm font-heading text-forest border-b-2 border-forest' }}
    >
      {label}
    </Link>
  );
}
